/**
 * this is just to sort our an entity using the field passed in
 * in x order
 * @param {*} entity
 * @param string field
 * @param {'ASC'|'DESC'} order defaults to 'ASC'
 */
export const sortByField = (entity, field, order = 'ASC') => {
  return entity.sort((entity1, entity2) => {
    if (order === 'ASC') {
      if (entity1[field].toLowerCase() > entity2[field].toLowerCase()) {
        return 1
      } else {
        return -1
      }
    }

    if (order === 'DESC') {
      if (entity2[field].toLowerCase() > entity1[field].toLowerCase()) {
        return 1
      } else {
        return -1
      }
    }

    return 0
  })
}

/**
 * Used in generating id for location object
 */
export const generateLocationId = ({ name, street }) =>
  ('location:' + name + ':street:' + street).replace(/\s/g, '').toLowerCase()



// WEBPACK FOOTER //
// ./src/helpers/utils.js